module.exports = __webpack_public_path__ + "static/img/balancascreen.d550a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/balancascreen.jpg
// module id = rsK2
// module chunks = 1